import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FieldOpsAuthService } from '../../services/field-ops-auth.service';
import { AuthService } from '../../../auth.service';

@Component({
  selector: 'app-fo-callback',
  standalone: false,
  templateUrl: './fo-callback.component.html',
  styleUrls: ['./fo-callback.component.css']
})
export class FoCallbackComponent implements OnInit {

  loading = true;
  error = '';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private fieldOpsAuthService: FieldOpsAuthService,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    const code = this.route.snapshot.queryParamMap.get('code');
    const state = this.route.snapshot.queryParamMap.get('state');

    if (!code) {
      this.loading = false;
      this.error = 'Authorisation was cancelled or failed. Please try again.';
      return;
    }

    const pgUserId = this.authService.userSubject.value?.id?.toString()
      || JSON.parse(sessionStorage.getItem('user') || '{}')?.id?.toString();
    const tenantId = sessionStorage.getItem('selectedTenant');

    if (!pgUserId) {
      this.loading = false;
      this.error = 'User session not found. Please log in and try again.';
      return;
    }

    this.fieldOpsAuthService.submitCallback(code, state || '', pgUserId, tenantId).subscribe({
      next: () => {
        this.router.navigate(['/field-ops/connected']);
      },
      error: () => {
        this.loading = false;
        this.error = 'Failed to complete the connection. Please try again.';
      }
    });
  }
}
